// Auto-generated by scripts/generate-version.mjs — DO NOT EDIT MANUALLY
export const APP_VERSION = '1.0.4-rc';
export const BUILD_DATE = '2026-01-27T15:57:43.042Z';
export const BUILD_ENV = 'Development';
export const GIT_SHA = '18c0749';
